import { fisheye360Path, fisheye180Path, bulletPath, covertPath, cubePath, domePath,
  ptzPath, turretPath, boxPath, lockIconPath, outlineLockIconPath } from './iconPaths'

export function cameraIconDetails(form, override, fisheyeAov) {
  if (!override && fisheyeAov) {
    return {
      path: fisheyeAov === 360 ? fisheye360Path : fisheye180Path,
      scale: .5,
      rotateOffset: fisheyeAov === 360 ? 0 : 180,
      anchor: new google.maps.Point(-148, 135)
    }
  }

  switch (!override && form) {
    case 'Bullet':
      return {
        path: bulletPath,
        scale: .6,
        rotateOffset: -90,
        anchor: new google.maps.Point(-121, 127)
      }
    case 'Covert':
      return {
        path: covertPath,
        scale: .55,
        rotateOffset: -90,
        anchor: new google.maps.Point(-160, 131)
      }
    case 'Cube':
      return {
        path: cubePath,
        scale: .7,
        rotateOffset: -90,
        anchor: new google.maps.Point(-155, 92)
      }
    case 'Dome':
      return {
        path: domePath,
        scale: .5,
        rotateOffset: 180,
        anchor: new google.maps.Point(-148, 135)
      }
    case 'PTZ':
      return {
        path: ptzPath,
        scale: .7,
        rotateOffset: 180,
        anchor: new google.maps.Point(-156, 131)
      }
    case 'Turret':
      return {
        path: turretPath,
        scale: .5,
        rotateOffset: 180,
        anchor: new google.maps.Point(-151, 128)
      }
    // Box or Generic
    default:
      return {
        path: boxPath,
        scale: 1.3,
        rotateOffset: 0,
        anchor: new google.maps.Point(-164, 109)
      }
  }
}

export default function getIconDetails({ showSimpleCameraIcon, form, fisheyeAov, color, heading, locked, isLens }) {
  const useBoxIcon = showSimpleCameraIcon || !form || form === 'Box'
  const icon = cameraIconDetails(form, showSimpleCameraIcon, fisheyeAov)

  const cameraIcon = {
    ...icon,
    strokeWeight: useBoxIcon ? 2.6 : 0,
    strokeColor: color,
    fillColor: color,
    fillOpacity: useBoxIcon ? 0 : 1,
    rotation: heading + icon.rotateOffset
  }

  const fisheyeIcon = {
    path: google.maps.SymbolPath.CIRCLE,
    strokeWeight: 2,
    strokeColor: '#ffffff',
    strokeOpacity: 0.75,
    scale: 15,
    fillColor: color,
    fillOpacity: 0.75
  }

  const lockIconDetails = {
    path: lockIconPath,
    scale: 0.5,
    strokeWeight: 1.7,
    rotation: useBoxIcon ? heading : heading - 90,
    strokeColor: color,
    anchor: useBoxIcon ? new google.maps.Point(10, -33) : new google.maps.Point(0, -10)
  }

  const outlineIcon = {
    path: locked ? outlineLockIconPath : icon.path,
    strokeWeight: 0,
    strokeColor: '#ffffff',
    scale: locked ? 0.45 : 0.38,
    fillColor: '#ffffff',
    fillOpacity: 0.7,
    anchor: new google.maps.Point(-148, 110)
  }

  return {
    cameraIcon: !showSimpleCameraIcon && fisheyeAov === 360 ? fisheyeIcon : cameraIcon,
    lockIconDetails,
    outlineIcon,
    showLockMarker: !isLens && locked && !EXPORT && (fisheyeAov !== 360 || showSimpleCameraIcon),
    showOutlineMarker: !isLens && !showSimpleCameraIcon && fisheyeAov === 360
  }
}



// WEBPACK FOOTER //
// ./src/components/Camera/helpers/getIconDetails.js